import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';
import { AcumaticaLoadingOptions } from '../loading-indicator/AcumaticaLoadingOptions';

@Injectable({
    providedIn: 'root'
})

export class TransferService extends AcumaticaEntityService {
    constructor(
        protected acumatica: AcumaticaService
    ) {
        super(acumatica, 'TransferOrder', Transfer);
    }

    get(
        ReferenceNbr: string,
        options: AcumaticaRequestOptions = {}
    ): Observable<Transfer> {
        return new Observable<Transfer>(observer => {
            // Get the Transfer Document
            return super.getEntity(ReferenceNbr, {
                ...{ loader: { message: "Getting Transfer" } },
                ...options
            }).subscribe(observer);
        })
    }

    put(
        transfer: Transfer,
        options: AcumaticaRequestOptions = {}
    ): Observable<Transfer> {
        return new Observable<Transfer>(observer => {
            return super.putEntity(transfer, {
                ...{ loader: { message: "Creating Transfer" } },
                ...options
            }).subscribe(observer);
        })
    }

    // Release(
    //     transfer: Transfer,
    //     options: AcumaticaLoadingOptions = {}
    // ): Observable<void> {
    //     return new Observable<void>(observer => {
    //         options = {
    //             ...{ loader: { message: "Releasing Transfer" } },
    //             ...options
    //         };
    //         let params = new AcumaticaEntity({ SetLocationFlag: true });

    //         // Transfer into Cut&Hold Bin issue -- hidden action in TransferEntry graph
    //         super.action(transfer, 'SetCutHoldLocationFlags', params, options).subscribe(() => {
    //             // Release the Transfer
    //             super.action(transfer, 'ReleaseTransferOrder', null, options).subscribe(() => {
    //                 // Restore Cut&Hold Bin flags
    //                 params = new AcumaticaEntity({ SetLocationFlag: false });
    //                 super.action(transfer, 'SetCutHoldLocationFlags', params, options).subscribe(() => {
    //                     observer.next();
    //                     observer.complete();
    //                 });
    //             });
    //         });
    //     })
    // }

    Release(
        transfer: Transfer,
        options: AcumaticaLoadingOptions = {}
    ): Observable<void> {
        return new Observable<void>(observer => {
            options = {
                ...{ loader: { message: "Releasing Transfer" } },
                ...options
            };
            super.action(transfer, 'ReleaseTransferOrder', null, options).subscribe(observer);
        });
    }
}

export class TransferDetail extends AcumaticaEntity {
    @Acumatica() InventoryID!: string;
    @Acumatica() FromLocationID!: string;
    @Acumatica() ToLocationID!: string;
    @Acumatica() UOM!: string;
    @Acumatica() Qty!: number;
    @Acumatica() LotSerialNbr!: string | null;
    @Acumatica() ReasonCode!: string | null;
    @Acumatica() Description!: string | null;

    constructor(init?: any) {
        super(init, {
            LotSerialNbr: null,
            ReasonCode: null,
            Description: null
        });
    }
}

export class Transfer extends AcumaticaEntity {
    @Acumatica() note!: string;
    @Acumatica() ReferenceNbr!: string;
    @Acumatica() ExternalRef?: string;
    @Acumatica() Status!: string;
    @Acumatica() Description?: string;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) Date!: Date;
    @Acumatica() FromWarehouseID!: string;
    @Acumatica() ToWarehouseID!: string;
    @Acumatica() TransferType: string = '1-Step';

    @Acumatica(TransferDetail) Details: TransferDetail[] = [];
}